export default "__VITE_ASSET__DSUIl$p8__"